/** Maximum number of context files that can be uploaded at once. */
export const CONTEXT_FILES_MAX_COUNT = 10;

/** Maximum total size of all context files in bytes (100MB). */
export const CONTEXT_FILES_MAX_TOTAL_SIZE = 100 * 1024 * 1024;
